<template>
  <PrintPage :pageNumber="pageNumber">
    <template v-slot:header>
      <slot>
        <PrintHeaderSSPSlim />
      </slot>
    </template>

    <div class="content-box">
      <div class="content-box-header">
        <h2>2. {{ $t('ballastAndUk') }}</h2>
      </div>
      <div class="two-column-grid">
        <div>{{ $t('brickAndUkAssemblyType') }}</div>
        <div>{{ $t(project.enpalReport.brickAndUkAssemblyType) }}</div>
        <div>{{ $t('ballastRockWeight') }}</div>
        <div>{{ project.enpalReport.ballastRockWeight }}</div>
      </div>
    </div>

    <AttachmentsPrintGrid
      :attachments="project.ballastAttachments"
      fieldName="ballastAttachments"
      :maxImages="4"
    />

    <AttachmentsPrintGrid
      :attachments="project.railToRoofDistanceAttachments"
      fieldName="railToRoofDistanceAttachments"
      :maxImages="2"
    />
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';
import PrintHeaderSSPSlim from '@/components/Print/PrintHeaderSSPSlim';
import AttachmentsPrintGrid from '@/components/Print/AttachmentsPrintGrid';
import { range } from '@/helpers/math.js';

export default {
  name: 'MeasurementPrintPage1',
  components: {
    PrintPage,
    PrintHeaderSSPSlim,
    AttachmentsPrintGrid,
  },
  props: {
    project: null,
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
  computed: {},
  methods: { range },
};
</script>
